<template>
    <div class="esrimap grid-container-content bg-primary-background" data-pin="/icons/stockland/location-filled.svg">
        <h1 v-if="header" class="heading-brand-base text-center col-span-full mb-9 p-no-margin retail:text-left logistics:md:text-left workplace:md:text-left logistics:md:col-start-2 retail:lg:col-start-2" v-html="header" />
        <section class="col-span-full centre-directory relative overflow-hidden">
            <div id="search" />
            <div id="map" class="map" />
        </section>
    </div>
</template>

<script lang="ts">
import { loadModules, loadScript } from 'esri-loader';

let app: any = {};

export default {
    name: 'esrimaps-map',
    props: {
        header: {
            type: String,
            default: () => ''
        },
        centreSapId: { type: String, default: () => '' },
        storeSapId: { type: String, default: () => '' },
        storeLayerName: { type: String, default: () => '' },
        mapName: { type: String, default: () => '' },
        retailStoreDetailsUrl: { type: String, default: () => '' },
    },
    mounted() {
        this.loadMap();
    },
    methods: {
        async loadMap() {
            const options = {
                url: 'https://js.arcgis.com/3.24/',
            };

            await loadScript(options);
            // Ensure the modules in the same order when loading them
            loadModules([
                "esri/map",
                "esri/tasks/QueryTask",
                "esri/graphic",
                "esri/symbols/SimpleFillSymbol",
                "esri/symbols/PictureMarkerSymbol",
                "dojo/_base/array",
                "esri/Color",
                "esri/tasks/query",
                "dojo/on",
                "dojo/promise/all",
                "esri/dijit/Search",
                "esri/arcgis/Portal",
                "esri/dijit/util/busyIndicator",
                "esri/arcgis/utils",
                "esri/geometry/Extent",
                "esri/layers/FeatureLayer",
                "dojo/domReady!",

            ]).then(
                ([  
                    Map,
                    QueryTask,
                    Graphic,
                    SimpleFillSymbol,
                    PictureMarkerSymbol, 
                    arrayUtils,
                    Color,
                    Query,
                    on,
                    all,
                    Search,
                    arcgisPortal,
                    busyIndicator,
                    arcgisUtils,
                    Extent,
                    FeatureLayer
                ]) => { 
                    
                    // Store specific map
                    if(this.storeSapId !== '' || this.storeSapId){
                        //Constants----------------------
                        arcgisUtils.arcgisUrl = "https://stockland.maps.arcgis.com/sharing/rest/content/items";
                        var portalURL = "https://stockland.maps.arcgis.com";
                        var levelFieldName = "level_";
                        var storeKeyField = "sap_mapfeat_externalkey";
                        var searchFieldName = "tradingname"; //This field is used in search widget as store name
                        var storeLayerName = "";
                        var storeSapId = "";
                        var mapName = "";
                        var centreIdFieldName = "sap_mapfeat_businessentity";
                        var extentBuffer = 40;

                        var map;
                        var store;
                        var storeLayer;
                        var highlightLayer;
                        var maxExtent;
                        var initExtent;

                        var mapLayersDic = {};  //Global variable to store all map layers (Added on 5-02-2019)
                        var flooredLayers = []; //Global variable to store the map layers that have a Level_ attribute (Added on 5-02-2019)

                        var lods = [
                            {
                                "level": 1,
                                "resolution": 1.058_335,
                                "scale": 4000
                            },
                            {
                                "level": 2,
                                "resolution": 0.714_376,
                                "scale": 2700
                            },
                            {
                                "level": 3,
                                "resolution": 0.529_168,
                                "scale": 2001
                            },
                            {
                                "level": 4,
                                "resolution": 0.396_876,
                                "scale": 1500
                            },
                            {
                                "level": 5,
                                "resolution": 0.317_301,
                                "scale": 1200
                            },
                            {
                                "level": 6,
                                "resolution": 0.238_125,
                                "scale": 900
                            },
                            {
                                "level": 7,
                                "resolution": 0.185_209,
                                "scale": 700
                            },
                            {
                                "level": 8,
                                "resolution": 0.132_292,
                                "scale": 500
                            },
                            {
                                "level": 9,
                                "resolution": 0.092_604,
                                "scale": 350
                            },
                            {
                                "level": 10,
                                "resolution": 0.066_146,
                                "scale": 250
                            },
                            {
                                "level": 11,
                                "resolution": 0.052_917,
                                "scale": 200
                            }
                        ];

                        var biHandle = busyIndicator.create("map");
                        biHandle.show();

                        let portal = new arcgisPortal.Portal(portalURL);
                        
                        // Create store map
                        let storeLayerNameString = this.storeLayerName;
                        let storeSapIdString = this.storeSapId;
                        let mapNameString = this.mapName;
                        let retailStoreDetailsUrlString = this.retailStoreDetailsUrl // AJAX service providing opening hours, etc.
                        on(portal, "load", function (p) {
                            portal.queryItems({
                                num: 1,
                                q: "type:'Web Map' AND title:'" + mapNameString + "'"
                            }).then(function (result) {
                                if (result.results.length === 0) {
                                    console.error("Could not find web map named " + mapNameString);
                                    biHandle.hide();
                                }
                                else {
                                    // console.log("Map with id " + result.results[0].id + " will be used");

                                    var storeLayer;

                                    arcgisUtils.getItem(result.results[0].id).then(function (portalItem) {
                                        storeLayer = arrayUtils.filter(portalItem.itemData.operationalLayers, function (layer) {
                                            return layer.title == storeLayerNameString;
                                        });

                                        var query = new Query();
                                        query.outFields = ['*'];
                                        query.returnGeometry = true;
                                        //    Modify to storesapid
                                        query.where = storeKeyField + " = '" + storeSapIdString + "'";

                                        var queryTask = new QueryTask(storeLayer[0].url);
                                        queryTask.execute(query, function (featureset) {
                                            store = featureset.features[0];
                                            var storeExtent = store.geometry.getExtent();
                                            storeExtent.xmin -= extentBuffer;
                                            storeExtent.ymin -= extentBuffer;
                                            storeExtent.xmax += extentBuffer;
                                            storeExtent.ymax += extentBuffer;

                                            arrayUtils.forEach(portalItem.itemData.bookmarks, function (bookmark) {
                                                if (bookmark.name == store.attributes[centreIdFieldName]) {
                                                    maxExtent = new Extent(bookmark.extent);
                                                };
                                            });

                                            arcgisUtils.createMap(portalItem.item.id, "map", {
                                                mapOptions: {
                                                    slider: true,
                                                    sliderPosition: "bottom-right",
                                                    isClickRecentre: false,
                                                    isDoubleClickZoom: false,
                                                    // isPinchZoom: false,
                                                    // isRubberBandZoom: false,
                                                    isKeyboardNavigation: false,
                                                    // isScrollWheel: false,
                                                    extent: storeExtent,
                                                    logo: false,
                                                    showAttribution: false,
                                                    lods: lods
                                                }

                                            }).then(function (response) {
                                                map = response.map;

                                                getStoreMapLayers(); //Call function to identify the map layers that have Level_ attributes (Added on 5-02-2019)

                                                //Filter the identified floored map layers by the level of the selected store (Added on 5-02-2019)
                                                arrayUtils.forEach(flooredLayers, function (flooredLayer) {
                                                    flooredLayer.setDefinitionExpression(levelFieldName + " = '" + store.attributes[levelFieldName] + "'");
                                                });

                                                addMapMarker();
                                                map.on('extent-change', restrictExtent);
                                                //map.disableScrollWheelZoom();
                                                addStoreHomeSlider();
                                                biHandle.hide();
                                            }, function (error) {
                                                console.log("Error:", error.code, "Message:", error.message);
                                                biHandle.hide();
                                            });

                                        });
                                    });
                                }
                            });
                        });


                    }else{
                        // Centre specific map
                        var start = Date.now();
                        arcgisUtils.arcgisUrl = 'https://stockland.maps.arcgis.com/sharing/rest/content/items';
                        var portalURL = 'https://stockland.maps.arcgis.com';
                        var searchFieldName = 'tradingname'; //This field is used in search widget as store name
                        var storeKeyField = 'sap_mapfeat_externalkey';
                        var levelFieldName = 'level_';
                        var levelLabelField = 'leveltext'; // This is formatted in the data as "Ground Floor", "Level 1", etc
                        var currentVisibleLevel = 'G';
                        var mapName = 'S4P_V2_Stockland_CP_Retail_Website';
                        var storeLayerName = 'S4P_V2_Stockland_CP_Retail_Website_WFL1 - StocklandStores';
                        var tenantedStoreLayerName = "";
                        var retailStoreDetailsUrlString = this.retailStoreDetailsUrl // AJAX service providing opening hours, etc.
                        var centreSapId = this.centreSapId;
                        var lods = [
                            {
                                level: 1,
                                resolution: 1.058_335,
                                scale: 4000,
                            },
                            {
                                level: 2,
                                resolution: 0.714_376,
                                scale: 2700,
                            },
                            {
                                level: 3,
                                resolution: 0.529_168,
                                scale: 2001,
                            },
                            {
                                level: 4,
                                resolution: 0.396_876,
                                scale: 1500,
                            },
                            {
                                level: 5,
                                resolution: 0.317_301,
                                scale: 1200,
                            },
                            {
                                level: 6,
                                resolution: 0.238_125,
                                scale: 900,
                            },
                            {
                                level: 7,
                                resolution: 0.185_209,
                                scale: 700,
                            },
                            {
                                level: 8,
                                resolution: 0.132_292,
                                scale: 500,
                            },
                            {
                                level: 9,
                                resolution: 0.092_604,
                                scale: 350,
                            },
                            {
                                level: 10,
                                resolution: 0.066_146,
                                scale: 250,
                            },
                            {
                                level: 11,
                                resolution: 0.052_917,
                                scale: 200,
                            },
                        ];

                        var bookmarks: any;
                        var mapLayersDic = {};
                        var flooredLayers: any[] = [];
                        var floorNumbers;
                        var initialExtent: { contains: (argument0: any) => any } | undefined;
                        var biHandle = busyIndicator.create('map');
                        biHandle.show();

                        var portal = new arcgisPortal.Portal(portalURL);

                        on(portal, 'load', function (p: any) {
                            portal
                                .queryItems({
                                    num: 1,
                                    q: "type:'Web Map' AND title:'" + mapName + "'",
                                })
                                .then(function (result: { results: string | any[] }) {
                                    console.log( "type:'Web Map' AND title:'" + mapName + "'" );
                                    if (result.results.length === 0) {
                                        console.error('Could not find web map named ' + mapName);
                                        biHandle.hide();
                                    } else {
                                        // console.log('Map with id ' + result.results[0].id + ' will be used'); // Used for testing
                                        arcgisUtils
                                            .createMap(result.results[0].id, 'map', {
                                                mapOptions: {
                                                    slider: true,
                                                    sliderPosition: 'bottom-right',
                                                    logo: false,
                                                    lods: lods,
                                                    showAttribution: false,
                                                },
                                            })
                                            .then(
                                                function (response) {
                                                  
                                                    app.map = response.map;

                                                    //This shows the popup window on top of the selected feature
                                                    app.map.infoWindow.set('anchor', 'top');
                                                    //app.map.infoWindow.set("border", "2px solid #fff;");

                                                    bookmarks = response.itemInfo.itemData.bookmarks;

                                                    getMapLayers();

                                                    // CentreSapId is supplied by the CMS
                                                    if (centreSapId === undefined) {
                                                        initialExtent = app.map.extent;
                                                    // console.log('Error zoom to bookmark: CentreSapId is undefined.'); // Used for testing
                                                    }
                                                    else {ZoomToBookmark(centreSapId);}

                                                    floorNumbers = getFloorNumbers();
                                                    addHighlightingEffect();
                                                
                                                    app.map.on('extent-change', function (event) {
                                                        if (!initialExtent) {
                                                            initialExtent = app.map.extent;
                                                        }

                                                        var extent = app.map.extent.getCenter();
                                                        if (!initialExtent?.contains(extent)) {
                                                            app.map.setExtent(initialExtent);
                                                        }
                                                    });

                                                    app.map.on('zoom-end', function (event) { });

                                                    app.map.graphics.enableMouseEvents();

                                                    addHomeSlider();

                                                    var queryString = window.location.href.slice(window.location.href.indexOf('?') + 1).split('#')[1];
                                                    if (queryString != null && queryString != '') {
                                                        var sid = queryString.split('&')[1];
                                                        var level = queryString.split('&')[2];
                                                        if (level == '0') {
                                                            level = 'G';
                                                        }
                                                        if (sid != null && sid != '') {
                                                            getStoreDetails(sid, "", "", result, level);
                                                        }
                                                    }

                                                    //Search widget
                                                    var search = new Search(
                                                        {
                                                            map: app.map,
                                                            allPlaceholder: 'Search stores',
                                                        },
                                                        'search'
                                                    );

                                                    search.on('load', function () {
                                                        let storesLayer = 'S4P_V2_Stockland_CP_Retail_Website_WFL1 - StocklandStores';
                                                        var sources = search.sources; //[];//search.get("sources");
                                                        //sources.clear();
                                                        sources.push({
                                                            featureLayer: new FeatureLayer(mapLayersDic[storesLayer].url),
                                                            searchFields: [searchFieldName],
                                                            suggestionTemplate: '${' + searchFieldName + '} - ${' + levelLabelField + '}',
                                                            displayField: searchFieldName,
                                                            placeholder: 'Search stores',
                                                            searchExtent: initialExtent,
                                                            exactMatch: false,
                                                            outFields: [searchFieldName, storeKeyField, levelFieldName],
                                                            name: 'Store Name',
                                                            maxResults: 6,
                                                            maxSuggestions: 6,
                                                            zoomScale: 6000,
                                                            enableSuggestions: true,
                                                            minCharacters: 0,
                                                        });
                                                        sources.splice(0, 1);
                                                        search.set('sources', sources);
                                                        search.activeSource = search.sources[0];
                                                        search.on('select-result', showSearchLocation);
                                                    });
                                                    search.startup();
                                                    biHandle.hide();
                                                    var end = Date.now();
                                                    var difference = (end - start) / 1000;
                                                // console.log(
                                                // 	'Centre Map load Time ' + 'Start Time: ' + start + ' End Time:' + end + 'Diff: ' + difference
                                                // ); // Used for testing
                                                },
                                                function (error) {
                                                    // console.log('Error: ', error.code, ' Message: ', error.message); // Used for testing
                                                    biHandle.hide();
                                                }
                                            );
                                    }
                                });
                        });
                    }

                    //Store Functions
                    //Function to identify map layers that have Level_ attribute (Added on 5-02-2019)
                    function getStoreMapLayers() {
                        arrayUtils.forEach(map.graphicsLayerIds, function (layerId) {
                            let layer = map.getLayer(layerId);
                            if (layerId != "labels") {
                                mapLayersDic[layer.arcgisProps.title] = layer;
                            }
                            if (layer.visible) {
                                let levelFields = arrayUtils.filter(layer.fields, function (field) {
                                    return field.name == levelFieldName;
                                });
                                if (levelFields.length > 0) {
                                    flooredLayers.push(layer);
                                }
                            }
                        });
                    }

                    function addStoreHomeSlider() {

                        //let's add the home button slider as a created class, requires dom-Attr  
                        dojo.create("div", {
                            className: "esriSimpleSliderHomeButton",
                            title: 'Zoom to Full Extent',
                            onclick: function () {
                                if (typeof storeExtent === 'undefined') {
                                    storeExtent = map.extent;
                                }
                                map.setExtent(storeExtent);
                            }
                        }, dojo.query(".esriSimpleSliderIncrementButton")[0], "after");
                    }

                    function addMapMarker() {
                        const mapReference = document.querySelector<HTMLElement>('.esrimap');
                        //Pin will not show on the FE as this is a BE specific path   
                        let markerSymbolURL = mapReference?.getAttribute('data-pin');
                        let storeMarkerSymbol = new PictureMarkerSymbol(markerSymbolURL, 61, 61);
                        storeMarkerSymbol.setOffset(-4,30);
                        let storeCentroid = store.geometry.getExtent().getCenter(); //Used getExtent().getCenter() to overcome an issue with getCentroid()

                        let storeMarkerGraphic = new Graphic(storeCentroid, storeMarkerSymbol);
                        map.graphics.add(storeMarkerGraphic);
                    };

                    function restrictExtent(event) {
                        // Prevent users from navigating away from this center
                        if (!maxExtent.expand(1.2).contains(map.extent.getCenter())) {
                            map.setExtent(maxExtent.expand(1.2));
                        }
                    }
                    //     let centreCode = centreSapId;
                    //     let storeCode = storeSapId;
                    //     const url = "https://www.stockland.com.au//public/map/GetEsriMapSettings";
                    //     const data = {
                    //         centreSapId: centreCode,
                    //         storeCode: storeCode
                    //     };

                    //     fetch(url, {
                    //         method: "POST",
                    //         body: JSON.stringify(data),
                    //         headers: {
                    //             "Content-Type": "application/json; charset=utf-8"
                    //         }
                    //     })
                    //         .then(response => {
                    //             if (response.ok) {
                    //                 return response.json();
                    //             } else {
                    //                 throw new Error(`Could not retrieve map settings: ${response.statusText}`);
                    //             }
                    //         })
                    //         .then(callback)
                    //         .catch(error => {
                    //             console.log(error.message);
                    //             callback("");
                    //         });

                    // }

                    // Centre Functions
                    function getMapLayers() {
                        arrayUtils.forEach(app.map.graphicsLayerIds, function (layerId: string) {
                            let layer = app.map.getLayer(layerId);
                            if (layerId != 'labels') {
                                mapLayersDic[layer.arcgisProps.title] = layer;
                            }
                            if (layer.visible) {
                                let levelFields = arrayUtils.filter(layer.fields, function (field: { name: string }) {
                                    return field.name == levelFieldName;
                                });

                                if (levelFields.length > 0) {
                                    flooredLayers.push(layer);
                                }
                            }
                        });
                    }

                    function ZoomToBookmark(bookmarkName: string) {
                        let bookmark = arrayUtils.filter(bookmarks, function (bookmark: { name: any }) {
                            return bookmark.name == bookmarkName;
                        });
                        if (bookmark.length > 0) {
                            initialExtent = new Extent(bookmark[0].extent);
                            app.map.setExtent(initialExtent);
                        } else {
                            initialExtent = app.map.extent;
                            // console.log('Error zoom to bookmark: CentreSapId = ' + bookmarkName + ' is invalid.'); // Used for testing
                        }
                    }

                    function getFloorNumbers() {
                        let query = new Query();
                        query.returnGeometry = false; // turn geometry off, required to be false when using returnDistinctValues
                        query.returnDistinctValues = true;
                        query.outFields = [levelFieldName];

                        //if (typeof CentreSapId !== 'undefined') {
                        //    query.where = centreIdFieldName + "='" + CentreSapId + "'";
                        //} else {
                        query.spatialRelationship = Query.SPATIAL_REL_CONTAINS;
                        query.geometry = initialExtent; //using map.extent caused problem. Seems the initialExtent has not been set to map yet
                        //}

                        let floors: any[] = [];
                        let defs: any[] = [];
                        arrayUtils.forEach(flooredLayers, function (flooredLayer: { url: any; name: string }) {
                            let queryTask = new QueryTask(flooredLayer.url);
                            defs.push(
                                queryTask.execute(
                                    query,
                                    function (featureset: { features: any }) {
                                        arrayUtils.forEach(featureset.features, function (feature: { attributes: { [x: string]: any } }) {
                                            let floor = feature.attributes[levelFieldName];
                                            if (!floors.includes(floor)) {
                                                floors.push(floor);
                                            }
                                        });
                                    },
                                    function (error: string) {
                                        console.error('Query failed against ' + flooredLayer.name + ' with error:' + error);
                                    }
                                )
                            );
                        });

                        all(defs).then(function () {
                            if (floors.length <= 1) return;

                            floors.sort(function (a, b) {
                                return (a == 'G' ? 0 : a) - (b == 'G' ? 0 : b);
                            });
                            let zoomSlider = document.querySelector('#map_zoom_slider');
                            arrayUtils.forEach(floors, function (floor: string) {
                                let lbl = document.createElement('label');
                                lbl.innerHTML = floor;
                                lbl.setAttribute('Class', 'input-check');

                                let input = document.createElement('input');
                                input.setAttribute('Type', 'checkbox');
                                input.setAttribute('ID', floor);
                                input.setAttribute('onchange', 'changeLevelsState(this)');
                                input.addEventListener('change', changeLevelsState);

                                //zoomSlider.appendChild(lbl);

                                zoomSlider.insertBefore(lbl, zoomSlider.childNodes[0]);

                                lbl.append(input);
                                if (floor == 'G') {
                                    lbl.classList.add('checked');
                                    input.checked = true;
                                    changeLevelsState(input);
                                }

                                let br = document.createElement('br');
                            });
                        });
                    }

                    function changeLevelsState(object: HTMLInputElement | null) {
                        if (object.target) object = object.target;
                        app.map.infoWindow.hide();
                        if (object?.checked) {
                            //Change the state of current visible lavel to unchecked
                            if (object.getAttribute('ID') != currentVisibleLevel) {
                                document.getElementById(currentVisibleLevel).checked = false;
                                changeLevelsState(document.getElementById(currentVisibleLevel));
                                currentVisibleLevel = object.getAttribute('ID');
                            }

                            //if checkbox is being checked, add a "checked" class
                            object.parentNode.classList.add('checked');

                            //trun the level on
                            arrayUtils.forEach(
                                flooredLayers,
                                function (flooredLayer: { setDefinitionExpression: (argument0: string) => void }) {
                                    flooredLayer.setDefinitionExpression(levelFieldName + " = '" + object.getAttribute('ID') + "'");
                                }
                            );
                        } else {
                            //else remove it
                            object.parentNode.classList.remove('checked');
                            //turn the level off
                        }
                    }

                    function showSearchLocation(event_) {
                        app.map.graphics.clear();

                        //Find this store level button element, turn it on and change the button state to checked
                        if (document.getElementById(event_.result.feature.attributes[levelFieldName])) {
                            let levelButton = document.getElementById(event_.result.feature.attributes[levelFieldName]);
                            levelButton.checked = true;
                            changeLevelsState(levelButton);
                        }
                        var sapid = event_.result.feature.attributes.sap_mapfeat_externalkey;
                        //var centerPoint = event_.result.extent.getCenter();
                        //var loc = app.map.toScreen(centerPoint);
                        var loc = event_.result.extent.getCenter();
                        app.map.infoWindow.set("fillSymbol", null);
                        app.map.infoWindow.set("anchor", "top");

                        var highlightSymbol = new SimpleFillSymbol(
                            SimpleFillSymbol.STYLE_SOLID,
                            null,
                            new Color([170, 190, 255, 0.35])
                        );

                        try {
                            var tradingName = event_.result.feature.attributes.tradingname;
                            getStoreDetails(sapid, loc, tradingName );
                        } catch {
                            console.log("There was a problem obtaining the details for this store")
                        }

                    }

                    function addHomeSlider() {
                        //let's add the home button slider as a created class, requires dom-Attr
                        dojo.create(
                            'div',
                            {
                                className: 'esriSimpleSliderHomeButton',
                                title: 'Zoom to Full Extent',
                                onclick: function () {
                                    if (initialExtent === undefined || initialExtent === undefined) {
                                        initialExtent = app.map.extent;
                                    }
                                    let inp = document.querySelector<HTMLInputElement>('#G');
                                    if (inp !== null) {
                                        inp.checked = true;
                                        changeLevelsState(inp);
                                    }
                                    app.map.setExtent(initialExtent);
                                },
                            },
                            dojo.query('.esriSimpleSliderIncrementButton')[0],
                            'after'
                        );
                    }
                    
                    // Popup Functions 
                    function addHighlightingEffect() {
                        var storeLayer = mapLayersDic['S4P_V2_Stockland_CP_Retail_Website_WFL1 - StocklandTenantedStores'];

                        var highlightSymbol = SimpleFillSymbol(
                            SimpleFillSymbol.STYLE_SOLID,
                            null,
                            new Color([170, 190, 255, 0.35])
                        );

                        var highlightedStore;
                        if (storeLayer != undefined) {
                            storeLayer.on("mouse-over", function (event_) {
                                app.map.graphics.clear();
                                app.map.setMapCursor("pointer");
                                var highlightGraphic = new Graphic(event_.graphic.geometry, highlightSymbol);
                                app.map.graphics.add(highlightGraphic);
                                highlightedStore = event_.graphic;
                            });
                        }

                        // Ensure the Search layer is off, so that the mouse-over and click work
                        // var searchLayer = mapLayersDic[storeLayerName + "_Search"]
                        // if (searchLayer !== undefined) {
                        //    searchLayer.setVisibility(false);
                        // }

                        //     app.map.graphics.on("mouse-out", function(evt) {
                        //         app.map.graphics.clear();
                        //         app.map.setMapCursor("default");
                        //     });
                        
                        app.map.graphics.on("click", function (event_ ) {
                            const storeKeyField = 'sap_mapfeat_externalkey';
                            if (highlightedStore) {
                                try {
                                    var tradingName = highlightedStore.attributes.tradingname;
                                    getStoreDetails(highlightedStore.attributes[storeKeyField], event_.mapPoint, tradingName);
                                } catch {
                                    console.log("There was a problem fetching details about this store");
                                }
                            }
                        });
                    }
                    function createPopupContent(storeInfoArray) {
                        var content = '<button class="titleButton close" title="Close"></button>';
                        if (Object.keys(storeInfoArray).length == 1) {
                            //Showing just the store name
                            var storename = storeInfoArray.StoreName;
                            content += '<div class="popup">' +
                                '<div class="store-name">' + storename + '</div>' +
                                '</div>';

                        }
                        else {
                            var storename = storeInfoArray.name;
                            var openingHours = storeInfoArray.openingHours;
                            var phoneNumber = storeInfoArray.phoneNumber;
                            var level = storeInfoArray.levelFrom;
                            var storePageUrl = storeInfoArray.url;

                            //Create popup html content
                            content += "<a  href =" + "'" + storePageUrl + "'" + ">" +
                                '<div class="popup"><table border="0"><tr><td class="store-name" colspan="2"><u>' + storename + '</u></td></tr>' +
                                '<tr><td class="store-opening-hours">Hours: </td><td class="store-opening-hours">' + openingHours + '</td></tr>' +
                                '<tr><td class="phone-number">Phone: </td><td class="phone-number">' + phoneNumber + '</td></tr>' +
                                '<tr><td class="store-level">Level: </td><td class="store-level">' + level + '</td></tr></table></div>' +
                                "</a>";
                        }

                        return content;
                    }

                    // function closeDialog() {
                    //     app.map.graphics.clear();
                    //     dijitPopup.close(dialog);
                    // }

                    async function getStoreDetails(sapId, loc, tradingName, result, level) {
                        if (sapId != '' && sapId != null) {
                            const url = `${ retailStoreDetailsUrlString}${ sapId }`;
                            
                            try {
                                let response = await fetch(url, {
                                    method: 'GET',
                                });
                                let data = await response.json();
                                setTimeout(() => {
                                    // Default to trading name if the response is empty
                                    if (!data || Object.keys(data).length === 0) {
                                        data = { StoreName: tradingName };
                                    }
    
                                    if (data && result && result.results.length > 0) {
                                        const storeLayerName = 'storeLayerName'; // Define storeLayerName if not defined
                                        arcgisUtils.getItem(result.results[0].id)
                                            .then(portalItem => {
                                                const storeLayer = portalItem.itemData.operationalLayers
                                                    .find(layer => layer.title === storeLayerName);
    
                                                const query = new Query();
                                                query.outFields = ['*'];
                                                query.returnGeometry = true;
                                                query.where = `${storeKeyField} = '${JSON.parse(data).SapId}'`;
    
                                                const queryTask = new QueryTask(storeLayer.url);
                                                return queryTask.execute(query);
                                            })
                                            .then(featureset => {
                                                if (level && level.trim() !== '') {
                                                    const levelButton = document.getElementById(level);
                                                    if (levelButton) {
                                                        levelButton.checked = true;
                                                        changeLevelsState(levelButton);
                                                    }
                                                }
                                                const store = featureset.features[0];
                                                if (store) {
                                                    loc = store.geometry.getExtent().getCenter();
                                                    DisplayPopContent(data, loc);
                                                }
                                            })
                                            .catch(error => console.error('Error executing query task:', error));
                                    } else {
                                        DisplayPopContent(data, loc);
                                    }
                                    
                                }, 200);

                                
                            } catch (error) {
                                console.error('Could not retrieve Store details:', error);
                            }
                        }
                    }

                    function DisplayPopContent(response, loc) {
                        var content = createPopupContent(response);
                        app.map.infoWindow.setTitle(" ");
                        app.map.infoWindow.setContent(content);
                        app.map.infoWindow.show(loc);
                        document.addEventListener("click", function(event_){
                            const target = (event_.target as Element)?.closest(".titleButton.close");
                        
                            if(target){
                                app.map.infoWindow.hide();
                            }
                        });
                    }
                }
            );
        },
    },
};
</script>

<style lang="css">
.esriPopup a{
    text-decoration: none !important;
}
.actionList{
    display: none;
}
#map_zoom_slider .esriSimpleSliderHomeButton{
    position: relative;
    display: grid;
    place-items: center;
}
.esriSimpleSliderHomeButton:hover.esriSimpleSliderHomeButton::before {
    filter: grayscale(3) brightness(3)
}

[data-theme="rtc"] #map_zoom_slider .esriSimpleSliderHomeButton::before {
    content: url("data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 27 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M23.8248 7.27523V0H18.2362V3.62387L13.3448 0.429369L0 9.14556V32H26.6878V9.14556L23.8248 7.27523ZM19.6101 1.37398H22.4508V6.37699L19.6101 4.52039V1.37398ZM15.9433 30.626H10.7462V22.2465H15.9433V30.626ZM25.3139 30.626H17.3173V20.8725H9.37226V30.626H1.3757V9.88922L13.3448 2.07128L25.3139 9.89094V30.626Z' fill='%232A6DF6'/%3E%3C/svg%3E");
}

.esriPopup .titleButton.close{
    background-image: url("data:image/svg+xml,%3Csvg width='8' height='8' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M19.1999 16L27.5427 24.3429L24.3427 27.5429L15.9999 19.2L7.65703 27.5429L4.45703 24.3429L12.7999 16L4.45703 7.65715L7.65703 4.45715L15.9999 12.8L24.3427 4.45715L27.5427 7.65715L19.1999 16Z' fill='%23A3A3A3'/%3E%3C/svg%3E%0A")  !important;
    top:12px;
    right:12px;
}  

.centre-directory .esriMapContainer .popup{
    background: #FFF !important;
}
.centre-directory .esriMapContainer .store-name {
    font-size: 0.875rem;
    font-weight: 400;
    color:rgba(var(--color-primary-accent-text));
    margin-top: 12px;
    text-decoration: underline
}
.centre-directory .esriMapContainer .contentPane{
    border:none;
    padding: 12px;
    border-radius: 4px 4px 0px 0px !important;
    transform: translateY(1px)
}

.esriPopup .esriPopupWrapper,
.esriPopup .pointer{
    box-shadow: none !important;
}
.centre-directory .arcgisSearch{
    top: 16px !important;
    left: 16px !important;
}

.centre-directory .esriMapContainer .pointer.bottom, .centre-directory .esriMapContainer .actionsPane, .centre-directory .esriMapContainer .contentPane{
    background: rgba(var(--color-primary-background));
} 

.centre-directory .esriMapContainer .store-opening-hours,
.centre-directory .esriMapContainer .phone-number,
.centre-directory .esriMapContainer .store-level
{
   color:#000;
   font-size: 0.75rem;
   margin-top:2px;
   text-decoration: none;
}
.popup td {
    padding-top: 4px;
    padding-bottom: 4px;
}
</style>
